export class MessageStatusEnum {
    readonly id: number;
    readonly label: string;

    public isIn = (arr: { id: number }[]): boolean => {
        arr = arr != null ? arr : [];
        return arr.findIndex(t => t.id === this.id) >= 0;
    };

    protected constructor(id: number, label: string) {
        this.id = id;
        this.label = label;
    }

    public static READ = new MessageStatusEnum(10, "Read");
    public static UNREAD = new MessageStatusEnum(0, "Unread");

    public static asArray = () => [
        MessageStatusEnum.READ,
        MessageStatusEnum.UNREAD,
    ];

    public static fromId = (id: number) =>
        MessageStatusEnum.asArray().find(t => t.id === id);
}
